// Gemeinsames Save-Registry für den „Übersicht & Mapping"-Tab des Artikel-Lister-Slots.
//
// Der Tab enthält mehrere Feld-Sektionen (Darstellung, Google-Shopping, Artikel-Mapping),
// die aus UNTERSCHIEDLICHEN Modulen in denselben Tab rendern. Der Chef möchte EINEN
// „Speichern"-Button statt einen pro Sektion. Jede Sektion trägt hier ihre Speicherfunktion
// ein; der eine Button (im Tab-Kopf) ruft alle ein und aggregiert das Ergebnis.
//
// Schlüssel ist das Übersicht-Tab-DOM-Element (`[data-detail-pane="overview"]`). Da bei jedem
// Neu-Render ein FRISCHES Element entsteht (neues innerHTML), beginnt das Registry pro Render
// automatisch leer - keine veralteten Einträge über Re-Renders hinweg (WeakMap).

export interface OverviewSaveSection {
  /** Kurzlabel für Fehlermeldungen, z. B. „Darstellung". */
  label: string;
  /** Persistiert die Sektion. Wirft NICHT - meldet Erfolg/Fehler über den Rückgabewert. */
  run: () => Promise<{ ok: boolean; msg?: string }>;
}

const REG = new WeakMap<HTMLElement, OverviewSaveSection[]>();

/** Findet das gemeinsame Übersicht-Tab-Element (oder fällt auf das Element selbst zurück). */
function scopeEl(el: HTMLElement): HTMLElement {
  return el.closest<HTMLElement>('[data-detail-pane="overview"]') ?? el;
}

/** Eine Sektion registriert ihre Speicherfunktion (Aufruf aus dem Sektions-Mount, `el` = Mount-Host). */
export function registerOverviewSave(el: HTMLElement, section: OverviewSaveSection): void {
  const scope = scopeEl(el);
  const list = REG.get(scope) ?? [];
  list.push(section);
  REG.set(scope, list);
}

/** Alle für diesen Tab registrierten Speicherfunktionen (Aufruf aus dem Sammel-Button). */
export function getOverviewSaves(el: HTMLElement): OverviewSaveSection[] {
  return REG.get(scopeEl(el)) ?? [];
}
